<template>
  <div class="g-container-box">
    <el-row class="g-header-container">
      <el-col :span="3">
        <div class="g-header-left">熟客控制台</div>
      </el-col>
      <el-col :span="16">
        <nav-head navSel="2"></nav-head>
      </el-col>
      <el-col :span="5">
        <op-head></op-head>
      </el-col>
    </el-row>

    <el-row class="g-view-container">
      <el-col :span="3" class="g-menu-container">
        <sidebar defaultSel="6"></sidebar>
      </el-col>

      <el-col :span="21" class="g-center-container">
        <div class="revenue-page">
          <!-- 顶部余额 -->
          <div class="balance-card">
            <div class="balance-left">
              <div class="balance-label">营收账户余额</div>
              <div class="balance-value">{{ displayBalance }}</div>
            </div>

            <div class="balance-actions">
              <el-button
                size="mini"
                type="primary"
                plain
                :loading="recordLoading || categoryLoading"
                @click="refreshPage"
              >
                刷新
              </el-button>

              <div class="balance-right">
                <i class="el-icon-wallet"></i>
              </div>
            </div>
          </div>

          <!-- 中间内容 -->
          <div class="content-card">
            <el-tabs v-model="activeTab" class="revenue-tabs">
              <!-- 营收记录 -->
              <el-tab-pane label="营收记录" name="record">
                <div class="table-wrap">
                  <el-table
                    :data="recordList"
                    border
                    stripe
                    v-loading="recordLoading"
                    class="revenue-table"
                    header-cell-class-name="table-header-cell"
                    empty-text="暂无营收记录"
                  >
                    <el-table-column
                      prop="time"
                      label="时间"
                      min-width="220"
                    ></el-table-column>

                    <el-table-column
                      prop="event"
                      label="事件"
                      min-width="300"
                    ></el-table-column>

                    <el-table-column
                      prop="amount"
                      label="金额"
                      min-width="180"
                      align="right"
                    >
                      <template slot-scope="scope">
                        <span
                          class="amount-text"
                          :class="{
                            'is-plus': Number(scope.row.amount) > 0,
                            'is-minus': Number(scope.row.amount) < 0
                          }"
                        >
                          {{ formatAmount(scope.row.amount) }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>

              <!-- 子栏目营收统计 -->
              <el-tab-pane label="子栏目营收统计" name="category">
                <div class="table-wrap">
                  <el-table
                    :data="categoryList"
                    border
                    stripe
                    v-loading="categoryLoading"
                    class="revenue-table"
                    header-cell-class-name="table-header-cell"
                    empty-text="暂无子栏目营收数据"
                  >
                    <el-table-column
                      prop="name"
                      label="子栏目"
                      min-width="260"
                    ></el-table-column>

                    <el-table-column
                      prop="totalAmount"
                      label="子栏目合计营收"
                      min-width="300"
                      align="right"
                    >
                      <template slot-scope="scope">
                        <span class="money-text">
                          {{ formatMoney(scope.row.totalAmount) }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var util = require("@/common/util.js");

import sidebar from "../../components/sidebar.vue";
import navHead from "../../components/navHead.vue";
import opHead from "../../components/opHead.vue";
import { API_YINGSHOU, API_ZLMYINSH } from "../../assets/js/api.js";

export default {
  name: "platformRevenuePage",

  components: {
    sidebar,
    navHead,
    opHead,
  },

  data() {
    return {
      activeTab: "record",

      balanceAmount: 0,

      recordLoading: false,
      categoryLoading: false,

      recordList: [],
      categoryList: [],
    };
  },

  computed: {
    displayBalance() {
      return this.formatMoney(this.balanceAmount) + "元";
    },
  },

  created() {
    this.initPage();
  },

  methods: {
    initPage() {
      this.getRecordList();
      this.getCategoryList();
    },

    refreshPage() {
      this.initPage();
    },

    // 营收记录：POST /system/revenueList
    getRecordList() {
      this.recordLoading = true;

      util.postData(
        API_YINGSHOU,
        {},
        (res) => {
          console.log("营收记录返回：", res);

          const list = this.normalizeList(res);
          this.recordList = list.map((item) => this.normalizeRecordItem(item));

          this.refreshBalanceAmount();
          this.recordLoading = false;
        },
        "application/json"
      );
    },

    // 子栏目营收统计：POST /system/revenueSubStats
    getCategoryList() {
      this.categoryLoading = true;

      util.postData(
        API_ZLMYINSH,
        {},
        (res) => {
          console.log("子栏目营收统计返回：", res);

          const list = this.normalizeList(res);
          this.categoryList = list.map((item) => this.normalizeCategoryItem(item));

          this.refreshBalanceAmount();
          this.categoryLoading = false;
        },
        "application/json"
      );
    },

    // 兼容不同后端返回结构：
    // data: []
    // data: { list: [] }
    // data: { records: [] }
    // data: { rows: [] }
    normalizeList(res) {
      const body = res && res.data ? res.data : {};
      const data = body.data;

      if (Array.isArray(data)) return data;

      if (data && Array.isArray(data.list)) return data.list;
      if (data && Array.isArray(data.records)) return data.records;
      if (data && Array.isArray(data.rows)) return data.rows;

      if (Array.isArray(body.list)) return body.list;
      if (Array.isArray(body.records)) return body.records;
      if (Array.isArray(body.rows)) return body.rows;

      return [];
    },

    normalizeRecordItem(item = {}) {
      const time =
        item.time ||
        item.createTime ||
        item.createdTime ||
        item.createdAt ||
        item.revenueTime ||
        item.addTime ||
        item.gmtCreate ||
        "";

      const event =
        item.event ||
        item.eventName ||
        item.name ||
        item.title ||
        item.typeName ||
        item.remark ||
        item.content ||
        "";

      const amount =
        item.amount !== undefined
          ? item.amount
          : item.money !== undefined
          ? item.money
          : item.revenue !== undefined
          ? item.revenue
          : item.price !== undefined
          ? item.price
          : item.totalAmount !== undefined
          ? item.totalAmount
          : 0;

      return {
        ...item,
        time,
        event,
        amount,
      };
    },

    normalizeCategoryItem(item = {}) {
      const name =
        item.name ||
        item.event ||
        item.eventName ||
        item.typeName ||
        item.title ||
        item.remark ||
        "未命名子栏目";

      const totalAmount =
        item.totalAmount !== undefined
          ? item.totalAmount
          : item.amount !== undefined
          ? item.amount
          : item.money !== undefined
          ? item.money
          : item.revenue !== undefined
          ? item.revenue
          : item.total !== undefined
          ? item.total
          : 0;

      return {
        ...item,
        name,
        totalAmount,
      };
    },

    // 余额展示：
    // 优先用子栏目合计，没有子栏目时用营收记录合计
    refreshBalanceAmount() {
      if (this.categoryList && this.categoryList.length) {
        this.balanceAmount = this.categoryList.reduce((sum, item) => {
          return sum + this.toNumber(item.totalAmount);
        }, 0);
        return;
      }

      if (this.recordList && this.recordList.length) {
        this.balanceAmount = this.recordList.reduce((sum, item) => {
          return sum + this.toNumber(item.amount);
        }, 0);
        return;
      }

      this.balanceAmount = 0;
    },

    toNumber(value) {
      if (value === "" || value === null || value === undefined) return 0;

      const str = String(value).replace(/,/g, "");
      const num = Number(str);

      return isNaN(num) ? 0 : num;
    },

    formatMoney(value) {
      const num = this.toNumber(value);

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatAmount(value) {
      const num = this.toNumber(value);

      const absNum = Math.abs(num).toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (num > 0) return `+${absNum}`;
      if (num < 0) return `-${absNum}`;
      return absNum;
    },
  },
};
</script>

<style lang="less" scoped>
.g-container-box {
  overflow: hidden;
  background: #f5f7fa;
}

.g-header-left {
  background-color: #5c6be8;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.g-menu-container {
  height: calc(100vh - 60px);
  background-color: #fff;
  border-right: 1px solid #ebeef5;
}

.g-center-container {
  overflow: auto;
  height: calc(100vh - 60px);
  background-color: #eff3f6;
  padding: 20px;
  box-sizing: border-box;
}

.revenue-page {
  min-height: 100%;
}

.balance-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  border-radius: 12px;
  padding: 22px 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(30, 60, 90, 0.05);
  border: 1px solid #ebeef5;
  margin-bottom: 18px;
  min-height: 92px;
}

.balance-left {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}

.balance-label {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-right: 16px;
}

.balance-value {
  font-size: 30px;
  font-weight: 700;
  color: #5c6be8;
  line-height: 1;
  min-height: 30px;
}

.balance-actions {
  display: flex;
  align-items: center;
}

.balance-actions .el-button {
  margin-right: 14px;
}

.balance-right {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(92, 107, 232, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5c6be8;
  font-size: 24px;
}

.content-card {
  background: #fff;
  border-radius: 12px;
  padding: 0 20px 20px;
  box-shadow: 0 4px 16px rgba(30, 60, 90, 0.05);
  border: 1px solid #ebeef5;
}

.revenue-tabs /deep/ .el-tabs__header {
  margin: 0;
}

.revenue-tabs /deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background: #ebeef5;
}

.revenue-tabs /deep/ .el-tabs__item {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: #606266;
}

.revenue-tabs /deep/ .el-tabs__item.is-active {
  font-weight: 600;
  color: #303133;
}

.revenue-tabs /deep/ .el-tabs__active-bar {
  height: 3px;
  background-color: #5c6be8;
}

.table-wrap {
  padding-top: 18px;
}

.revenue-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.revenue-table /deep/ .table-header-cell {
  background: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
}

.revenue-table /deep/ .el-table__row td {
  color: #606266;
}

.revenue-table /deep/ .cell {
  padding-left: 18px;
  padding-right: 18px;
}

.amount-text {
  font-weight: 600;
}

.amount-text.is-plus {
  color: #303133;
}

.amount-text.is-minus {
  color: #f56c6c;
}

.money-text {
  font-weight: 600;
  color: #303133;
}

@media screen and (max-width: 1400px) {
  .g-center-container {
    padding: 16px;
  }

  .balance-card {
    padding: 18px 20px;
  }

  .balance-label {
    font-size: 16px;
  }

  .balance-value {
    font-size: 24px;
    margin-top: 8px;
    min-height: 24px;
  }

  .content-card {
    padding: 0 16px 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/e/index.vue